import API_URLS from '../../constants/api-urls';
import axios from '../../utils/axios';

export const logoutRequest = () => axios.get(API_URLS.LOGOUT);
